import clsx from 'clsx';
import { Field, useField } from 'formik';
import React, { useEffect, useState } from 'react';

import FieldError from './FieldError';
import FieldLabel from './FieldLabel';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  inputClassName?: string;
  label?: string;
  maxCharCount?: number;
  pretype?: string;
  preset?: string;
  type?: string;
};

const Input = ({
  className,
  id,
  inputClassName,
  label,
  maxCharCount,
  name,
  pretype,
  ...rest
}: InputProps) => {
  const [field, meta] = useField(name);
  const [charCount, setCharCount] = useState(field.value?.length || 0);

  useEffect(() => {
    if (maxCharCount) {
      setCharCount(field.value?.length || 0);
    }
  }, [field.value, maxCharCount]);

  return (
    <div className={className}>
      {label && <FieldLabel htmlFor={name}>{label}</FieldLabel>}
      {pretype ? (
        <div className="flow-row flex">
          <div className="z-10 -mr-2 flex h-[50px] items-center border border-r-0 border-solid border-grayscale-beige bg-white py-16 pl-8 font-suisse-intl text-overline-md text-grayscale-gray">
            {pretype}
          </div>
          <Field id={id} name={name} className={inputClassName} {...rest} {...field} />
        </div>
      ) : (
        <Field id={id} name={name} className={inputClassName} {...rest} {...field} />
      )}
      {maxCharCount && (
        <div
          className={clsx('mt-4 font-suisse-screen text-disclosure-sm text-grayscale-gray', {
            'text-primary-magenta': meta.error,
          })}
        >
          ({charCount}/{maxCharCount})
        </div>
      )}
      {meta.touched && meta.error && <FieldError>{meta.error}</FieldError>}
    </div>
  );
};

export default Input;
